import { USStateObject } from './constants';
import alabamaG from './svgGray/alabama.svg';
import alaskaG from './svgGray/alaska.svg';
import arizonaG from './svgGray/arizona.svg';
import arkansasG from './svgGray/arkansas.svg';
import californiaG from './svgGray/california.svg';
import coloradoG from './svgGray/colorado.svg';
import connecticutG from './svgGray/connecticut.svg';
import washingtonDcG from './svgGray/dC.svg';
import delawareG from './svgGray/delaware.svg';
import floridaG from './svgGray/florida.svg';
import georgiaG from './svgGray/georgia.svg';
import hawaiiG from './svgGray/hawaii.svg';
import idahoG from './svgGray/idaho.svg';
import illinoisG from './svgGray/illinois.svg';
import indianaG from './svgGray/indiana.svg';
import iowaG from './svgGray/iowa.svg';
import kansasG from './svgGray/kansas.svg';
import kentuckyG from './svgGray/kentucky.svg';
import louisianaG from './svgGray/louisiana.svg';
import maineG from './svgGray/maine.svg';
import marylandG from './svgGray/maryland.svg';
import massachusettsG from './svgGray/massachusetts.svg';
import michiganG from './svgGray/michigan.svg';
import minnesotaG from './svgGray/minnesota.svg';
import mississippiG from './svgGray/mississippi.svg';
import missouriG from './svgGray/missouri.svg';
import montanaG from './svgGray/montana.svg';
import nebraskaG from './svgGray/nebraska.svg';
import nevadaG from './svgGray/nevada.svg';
import newHampshireG from './svgGray/newHampshire.svg';
import newjerseyG from './svgGray/newJersey.svg';
import newMexicoG from './svgGray/newMexico.svg';
import newYorkG from './svgGray/newYork.svg';
import northCarolinaG from './svgGray/northCarolina.svg';
import northDakotaG from './svgGray/northDakota.svg';
import ohioG from './svgGray/ohio.svg';
import oklahomaG from './svgGray/oklahoma.svg';
import oregonG from './svgGray/oregon.svg';
import pensylvaniaG from './svgGray/pennsylvania.svg';
import rhodeIslandG from './svgGray/rhodeIsland.svg';
import southCarolinaG from './svgGray/southCarolina.svg';
import southDakotaG from './svgGray/southDakota.svg';
import tennaseeG from './svgGray/tennessee.svg';
import texasG from './svgGray/texas.svg';
import utahG from './svgGray/utah.svg';
import vermontG from './svgGray/vermont.svg';
import virginiaG from './svgGray/virginia.svg';
import washingtonG from './svgGray/washington.svg';
import westVirginiaG from './svgGray/westVirginia.svg';
import wisconsinG from './svgGray/wisconsin.svg';
import wyomingG from './svgGray/wyoming.svg';
import alabamaW from './svgWhite/alabama.svg';
import alaskaW from './svgWhite/alaska.svg';
import arizonaW from './svgWhite/arizona.svg';
import arkansasW from './svgWhite/arkansas.svg';
import californiaW from './svgWhite/california.svg';
import coloradoW from './svgWhite/colorado.svg';
import connecticutW from './svgWhite/connecticut.svg';
import washingtonDcW from './svgWhite/dC.svg';
import delawareW from './svgWhite/delaware.svg';
import floridaW from './svgWhite/florida.svg';
import georgiaW from './svgWhite/georgia.svg';
import hawaiiW from './svgWhite/hawaii.svg';
import idahoW from './svgWhite/idaho.svg';
import illinoisW from './svgWhite/illinois.svg';
import indianaW from './svgWhite/indiana.svg';
import iowaW from './svgWhite/iowa.svg';
import kansasW from './svgWhite/kansas.svg';
import kentuckyW from './svgWhite/kentucky.svg';
import louisianaW from './svgWhite/louisiana.svg';
import maineW from './svgWhite/maine.svg';
import marylandW from './svgWhite/maryland.svg';
import massachusettsW from './svgWhite/massachusetts.svg';
import michiganW from './svgWhite/michigan.svg';
import minnesotaW from './svgWhite/minnesota.svg';
import mississippiW from './svgWhite/mississippi.svg';
import missouriW from './svgWhite/missouri.svg';
import montanaW from './svgWhite/montana.svg';
import nebraskaW from './svgWhite/nebraska.svg';
import nevadaW from './svgWhite/nevada.svg';
import newHampshireW from './svgWhite/newHampshire.svg';
import newjerseyW from './svgWhite/newJersey.svg';
import newMexicoW from './svgWhite/newMexico.svg';
import newYorkW from './svgWhite/newYork.svg';
import northCarolinaW from './svgWhite/northCarolina.svg';
import northDakotaW from './svgWhite/northDakota.svg';
import ohioW from './svgWhite/ohio.svg';
import oklahomaW from './svgWhite/oklahoma.svg';
import oregonW from './svgWhite/oregon.svg';
import pensylvaniaW from './svgWhite/pennsylvania.svg';
import rhodeIslandW from './svgWhite/rhodeIsland.svg';
import southCarolinaW from './svgWhite/southCarolina.svg';
import southDakotaW from './svgWhite/southDakota.svg';
import tennaseeW from './svgWhite/tennessee.svg';
import texasW from './svgWhite/texas.svg';
import utahW from './svgWhite/utah.svg';
import vermontW from './svgWhite/vermont.svg';
import virginiaW from './svgWhite/virginia.svg';
import washingtonW from './svgWhite/washington.svg';
import westVirginiaW from './svgWhite/westVirginia.svg';
import wisconsinW from './svgWhite/wisconsin.svg';
import wyomingW from './svgWhite/wyoming.svg';

export const DEFAULT_US_STATE: USStateObject = {
  stateName: 'Florida',
  stateID: 'FL',
  svgWhite: floridaW,
  svgGray: floridaG,
};

export const US_STATES: USStateObject[] = [
  { stateName: 'Alabama', stateID: 'AL', svgWhite: alabamaW, svgGray: alabamaG },
  { stateName: 'Alaska', stateID: 'AK', svgWhite: alaskaW, svgGray: alaskaG },
  { stateName: 'Arizona', stateID: 'AZ', svgWhite: arizonaW, svgGray: arizonaG },
  { stateName: 'Arkansas', stateID: 'AR', svgWhite: arkansasW, svgGray: arkansasG },
  { stateName: 'California', stateID: 'CA', svgWhite: californiaW, svgGray: californiaG },
  { stateName: 'Colorado', stateID: 'CO', svgWhite: coloradoW, svgGray: coloradoG },
  { stateName: 'Connecticut', stateID: 'CT', svgWhite: connecticutW, svgGray: connecticutG },
  { stateName: 'Delaware', stateID: 'DE', svgWhite: delawareW, svgGray: delawareG },
  { stateName: 'Florida', stateID: 'FL', svgWhite: floridaW, svgGray: floridaG },
  { stateName: 'Georgia', stateID: 'GA', svgWhite: georgiaW, svgGray: georgiaG },
  { stateName: 'Hawaii', stateID: 'HI', svgWhite: hawaiiW, svgGray: hawaiiG },
  { stateName: 'Idaho', stateID: 'ID', svgWhite: idahoW, svgGray: idahoG },
  { stateName: 'Illinois', stateID: 'IL', svgWhite: illinoisW, svgGray: illinoisG },
  { stateName: 'Indiana', stateID: 'IN', svgWhite: indianaW, svgGray: indianaG },
  { stateName: 'Iowa', stateID: 'IA', svgWhite: iowaW, svgGray: iowaG },
  { stateName: 'Kansas', stateID: 'KS', svgWhite: kansasW, svgGray: kansasG },
  { stateName: 'Kentucky', stateID: 'KY', svgWhite: kentuckyW, svgGray: kentuckyG },
  { stateName: 'Louisiana', stateID: 'LA', svgWhite: louisianaW, svgGray: louisianaG },
  { stateName: 'Maine', stateID: 'ME', svgWhite: maineW, svgGray: maineG },
  { stateName: 'Maryland', stateID: 'MD', svgWhite: marylandW, svgGray: marylandG },
  { stateName: 'Massachusetts', stateID: 'MA', svgWhite: massachusettsW, svgGray: massachusettsG },
  { stateName: 'Michigan', stateID: 'MI', svgWhite: michiganW, svgGray: michiganG },
  { stateName: 'Minnesota', stateID: 'MN', svgWhite: minnesotaW, svgGray: minnesotaG },
  { stateName: 'Mississippi', stateID: 'MS', svgWhite: mississippiW, svgGray: mississippiG },
  { stateName: 'Missouri', stateID: 'MO', svgWhite: missouriW, svgGray: missouriG },
  { stateName: 'Montana', stateID: 'MT', svgWhite: montanaW, svgGray: montanaG },
  { stateName: 'Nebraska', stateID: 'NE', svgWhite: nebraskaW, svgGray: nebraskaG },
  { stateName: 'Nevada', stateID: 'NV', svgWhite: nevadaW, svgGray: nevadaG },
  { stateName: 'New Hampshire', stateID: 'NH', svgWhite: newHampshireW, svgGray: newHampshireG },
  { stateName: 'New Jersey', stateID: 'NJ', svgWhite: newjerseyW, svgGray: newjerseyG },
  { stateName: 'New Mexico', stateID: 'NM', svgWhite: newMexicoW, svgGray: newMexicoG },
  { stateName: 'New York', stateID: 'NY', svgWhite: newYorkW, svgGray: newYorkG },
  { stateName: 'North Carolina', stateID: 'NC', svgWhite: northCarolinaW, svgGray: northCarolinaG },
  { stateName: 'North Dakota', stateID: 'ND', svgWhite: northDakotaW, svgGray: northDakotaG },
  { stateName: 'Ohio', stateID: 'OH', svgWhite: ohioW, svgGray: ohioG },
  { stateName: 'Oklahoma', stateID: 'OK', svgWhite: oklahomaW, svgGray: oklahomaG },
  { stateName: 'Oregon', stateID: 'OR', svgWhite: oregonW, svgGray: oregonG },
  { stateName: 'Pennsylvania', stateID: 'PA', svgWhite: pensylvaniaW, svgGray: pensylvaniaG },
  { stateName: 'Rhode Island', stateID: 'RI', svgWhite: rhodeIslandW, svgGray: rhodeIslandG },
  { stateName: 'South Carolina', stateID: 'SC', svgWhite: southCarolinaW, svgGray: southCarolinaG },
  { stateName: 'South Dakota', stateID: 'SD', svgWhite: southDakotaW, svgGray: southDakotaG },
  { stateName: 'Tennessee', stateID: 'TN', svgWhite: tennaseeW, svgGray: tennaseeG },
  { stateName: 'Texas', stateID: 'TX', svgWhite: texasW, svgGray: texasG },
  { stateName: 'Utah', stateID: 'UT', svgWhite: utahW, svgGray: utahG },
  { stateName: 'Vermont', stateID: 'VT', svgWhite: vermontW, svgGray: vermontG },
  { stateName: 'Virginia', stateID: 'VA', svgWhite: virginiaW, svgGray: virginiaG },
  { stateName: 'Washington', stateID: 'WA', svgWhite: washingtonW, svgGray: washingtonG },
  { stateName: 'Washington, D.C.', stateID: 'DC', svgWhite: washingtonDcW, svgGray: washingtonDcG },
  { stateName: 'West Virginia', stateID: 'WV', svgWhite: westVirginiaW, svgGray: westVirginiaG },
  { stateName: 'Wisconsin', stateID: 'WI', svgWhite: wisconsinW, svgGray: wisconsinG },
  { stateName: 'Wyoming', stateID: 'WY', svgWhite: wyomingW, svgGray: wyomingG },
];
